import _ from 'lodash';
import { NumberRange } from '../api/apiTypes';

function isFilterValueFilled(value: unknown): boolean {
  if (_.isBoolean(value)) {
    return value === true;
  }

  if (_.isNumber(value)) {
    return true;
  }

  return !_.isEmpty(value);
}

export function getUsedFilterCount(filter: object, excludedKeys: string[] = []): number {
  return Object
    .entries(filter)
    .reduce((count, [key, value]) => {
      if (excludedKeys.includes(key)) {
        return count;
      }

      if (Array.isArray(value)) {
        return count + value.length;
      }

      if (isFilterValueFilled(value)) {
        return count + 1;
      }

      return count;
    }, 0);
}

export function getValueIfNotEmpty<T>(value: T | ''): T | undefined {
  if (_.isNumber(value)) {
    return value;
  }

  return _.isEmpty(value) ? undefined : (value as T);
}

export function getBooleanValueOnlyIfTrue(value: boolean | ''): true | undefined {
  return value === true ? true : undefined;
}

export function getArrayIfNotEmpty<T>(value: T[]): T[] | undefined {
  return _.isEmpty(value) ? undefined : value;
}

export function getRangeIfNotEmpty(
  from: number | undefined,
  to: number | undefined,
): NumberRange | undefined {
  const fromValue = from ?? null;
  const toValue = to ?? null;

  if (fromValue === null && toValue === null) {
    return undefined;
  }

  return {
    from: fromValue,
    to: toValue,
  };
}

export function getEmptyIfUndefined<T>(value: T | undefined | null): T | '' {
  return value ?? '';
}
